import {
  createContext, Dispatch, ReactNode, SetStateAction, useContext, useMemo, useState,
} from 'react';
import { ObjectEvent } from 'ol/Object';
import { OnHoverEvent } from 'types/openlayers.types';
import MainAppContext from '../MainAppContext';

interface TileViewContextValues {
    mousePosition: number[],
    setMousePosition: Dispatch<SetStateAction<number[]>>,
    syncLayers: boolean,
    onHoverEvent?: OnHoverEvent,
    zoomEvent?: ObjectEvent,
    captureOnHoverEvent: (event: OnHoverEvent) => void,
    captureZoomEvent: (event: ObjectEvent) => void,
}

const TileViewContext = createContext<TileViewContextValues>({
  mousePosition: [0, 0],
  setMousePosition: () => {},
  syncLayers: true,
  onHoverEvent: undefined,
  captureOnHoverEvent: () => {},
  zoomEvent: undefined,
  captureZoomEvent: () => {},

});

interface TileViewProviderProps {
    children: ReactNode
}

function TileViewProvider({ children } : TileViewProviderProps) {
  const { syncLayers } = useContext(MainAppContext);
  const [mousePosition, setMousePosition] = useState<number[]>([]);
  const [onHoverEvent, captureOnHoverEvent] = useState<OnHoverEvent>();
  const [zoomEvent, captureZoomEvent] = useState<ObjectEvent>();

  return (
    <TileViewContext.Provider value={useMemo(() => ({
      mousePosition,
      setMousePosition,
      syncLayers,
      captureOnHoverEvent,
      onHoverEvent,
      zoomEvent,
      captureZoomEvent,
    }), [mousePosition, onHoverEvent, syncLayers, zoomEvent])}
    >
      {children}
    </TileViewContext.Provider>
  );
}

export { TileViewProvider };
export default TileViewContext;
